<template>
  <b-modal
    size="lg"
    centered
    no-close-on-backdrop
    ok-title="Enviar"
    id="modal-edit"
    modal
    :title="$ml.get('editMessage')"
  >
    <div class="m-3">
      <div class="d-flex justify-content-between">
        <input
          class="form-control filterInput col-12 mb-3"
          v-model="title_message"
          :placeholder="$ml.get('placeholderTitleMessage')"
          aria-label="Search"
        />
        <multiselect
          class="col-11"
          v-model="optionSelected"
          :options="listOptions"
          :searchable="false"
          label="name"
          :close-on-select="true"
          :custom-label="nameLang"
          :show-labels="false"
          :allow-empty="false"
          :preselect-first="true"
          :multiple="false"
          :placeholder="$ml.get('select')"
          :disabled="true"
        ></multiselect>
      </div>
      <div
        v-if="type === 'comment'"
        class="custom-control custom-checkbox mb-3 box-automatic-message"
        v-b-tooltip.hover
        :title="$ml.get('automaticMessage')"
      >
        <input
          type="checkbox"
          class="custom-control-input"
          v-model="automaticMessage"
        />
        <label
          class="custom-control-label"
          v-text="$ml.get('labelAutomatic')"
        ></label>
      </div>
      <textarea
        id=""
        class="form-control w-100 text-are-mark"
        rows="7"
        v-model="description_message"
        :placeholder="$ml.get('placeholderTextAreaMessage')"
      >
      </textarea>
    </div>
    <template #modal-footer="{ ok, cancel }">
      <b-button
        style="background: #730ba9; width: 90px"
        size="sm"
        @click="ok(), updateMessage()"
      >
        Salvar
      </b-button>
      <b-button
        class="float-right btn-outline-extra"
        size="sm"
        variant="primary"
        @click="cancel(), cancelMessage()"
      >
        {{ $ml.get("cancel") }}
      </b-button>
    </template>
  </b-modal>
</template>
<script>
import Swal from "sweetalert2";
import CompanyService from "../../../services/company.service";
export default {
  name: "ModalEditMessage",
  props: {
    idMessage: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    message: {
      type: String,
      required: true,
    },
    is_automatic: {
      type: Boolean,
      required: true,
    },
    type: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      title_message: this.title,
      description_message: this.message,
      automaticMessage: this.is_automatic,

      optionSelected: { name: "comment", id: "comment" },

      listOptions: [
        { name: "comment", id: "comment" },
        { name: "waiting_for_information", id: "waiting_for_information" },
        { name: "under_review", id: "under_review" },
        { name: "triaged", id: "triaged" },
        { name: "retest_requested", id: "retest_requested" },
        { name: "bounty_paid", id: "bounty_paid" },
        { name: "close_as_approved", id: "close_as_approved" },
        { name: "close_as_informative", id: "close_as_informative" },
        { name: "close_as_spam", id: "close_as_spam" },
        { name: "close_as_duplicated", id: "close_as_duplicated" },
        { name: "close_as_not_applicable", id: "close_as_not_applicable" },
      ],
    };
  },
  watch: {
    title() {
      this.title_message = this.title;
    },
    message() {
      this.description_message = this.message;
    },
    is_automatic() {
      this.automaticMessage = this.is_automatic;
    },
    type() {
      this.optionSelected.name = this.type;
      this.optionSelected.id = this.type;
    },
  },

  methods: {
    async fetchData() {
      try {
        const { data } = await CompanyService.getMessageDefault();
        this.messages = data ? this.mergeObject(data) : [];
      } catch (error) {
        console.log(error);
      }
    },

    updateMessage() {
      const payload = {
        title: this.title_message,
        type: this.optionSelected.id,
        message: this.description_message,
        is_automatic: this.automaticMessage ? "yes" : "no",
      };

      CompanyService.putMessageDefault(this.idMessage, payload).then(
        (response) => {
          console.log(response);
          this.$emit("update-data");
          if (response.data === "Mensagem salva!") {
            Swal.fire({
              icon: "success",
              title: this.$ml.get("alertMessageUpdate"),
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
            });
          }
        },
      );
    },
    cancelMessage() {
      this.description_message = "";
      this.title_message = "";
    },
    nameLang({ name }) {
      return `${this.$ml.get(name)}`;
    },
  },
};
</script>
<style scoped>
.box-automatic-message {
  width: 130px;
}
</style>
